module.exports = __webpack_public_path__ + "img/icon-xing.25b74c88.svg";